export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'image',
		label: 'Image',
		selector: '& img'
	}
]